export default "__VITE_ASSET__fGozkIlg__"